import getSalesTypeOptions from 'helpers/getSalesTypeOptions';
import salesTypes from 'maps/sales-types';

const getSalesForCustomLists = (
  isExternalUser: boolean,
  hasMedia: boolean
): any => {
  const saleTypes = [
    salesTypes.streaming,
    salesTypes.downloads,
    ...(hasMedia ? [] : [salesTypes.physical]),
  ];
  return isExternalUser ? saleTypes : [salesTypes.equivalents, ...saleTypes];
};

const getSalesType = (props: any): any => {
  const {
    isExternalUser,
    entityType,
    hasSplitDownloads,
    forceNoEquivalents,
    tableName,
    hasMedia,
  } = props;
  return tableName === 'customLists'
    ? getSalesForCustomLists(isExternalUser, hasMedia)
    : getSalesTypeOptions(
        isExternalUser,
        entityType,
        hasSplitDownloads,
        forceNoEquivalents,
        hasMedia
      );
};

export default getSalesType;
